import * as actionTypes from '../actions/types';
//import { userData } from './userData';

const savedUser = localStorage.getItem('user');
const savedProfile = JSON.parse(localStorage.getItem('userProfile'));
const savedPreferences = JSON.parse(localStorage.getItem('preferences'));

const initialState = {
    profile: {
        userId: savedUser !== undefined ? savedUser : null,
        profileName: '',
        dateOfBirth: '',
        gender: '',
        profilePhotos: [],
        universityInfo: { campus: '', faculty: '' },
        interests: [],
        virtue: {
            genderPreference: '', ethnicity: '', religion: '', politicalView: '',
            smoking: '', drinking: '', height: ''
        },
        bio: '',
        isActive: true,
        profilePrompts: []
    },
    userProfile: savedProfile !== undefined ? savedProfile : null,
    virtueStep: 0,
    profiles: [],
    preferenceFilters: savedPreferences !== undefined ? savedPreferences : null,
    errors: null
};

const profileReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_PROFILES:
            return {...state, profiles: action.payload};

        case actionTypes.START_FETCH_USER_PROFILE:
            return {...state, loading: true}

        case actionTypes.SUCCESS_FETCH_USER_PROFILE:
            return {...state, userProfile: action.payload, loading: false};

        case actionTypes.ERROR_FETCH_USER_PROFILE:
            return {...state, errors: action.errors, loading: false};

        case actionTypes.COLLECT_PROFILE_DATA:
            return {...state, profile: action.payload};

        case actionTypes.PREFERENCE_FILTERS_UPDATE:
            return {...state, preferenceFilters: action.payload};

        case actionTypes.CREATE_PROFILE:
            return {...state, userProfile: action.payload, errors: action.errors};

        case actionTypes.UPDATE_PROFILE:
            return {...state, userProfile: action.payload, errors: action.errors};

        case actionTypes.ADD_PROFILE_PROMPTS: 
            return {...state, userProfile: {...state.userProfile, profilePrompts: action.payload}, errors: action.errors};

        case actionTypes.UPDATE_PROFILE_PROMPT: 
            return {...state, userProfile: {...state.userProfile, profilePrompts: action.payload}, errors: action.errors};

        case actionTypes.ADD_PROFILE_INTEREST: 
            return {...state, userProfile: action.payload, errors: action.errors};

        case actionTypes.REMOVE_PROFILE_INTEREST: 
            return {...state, userProfile: action.payload, errors: action.errors};

        case actionTypes.ADD_PROFILE_PHOTO:
            return {...state, userProfile: {...state.userProfile, profilePhotos: action.payload}, errors: action.errors};

        case actionTypes.REMOVE_PROFILE_PHOTO:
            return {...state, userProfile: {...state.userProfile, profilePhotos: action.payload}, errors: action.errors};

        case actionTypes.RESET_VIRTUE:
            return {...state, virtueStep: 0};

        case actionTypes.PREVIOUS_VIRTUE:
            return {...state, virtueStep: state.virtueStep-1};

        case actionTypes.NEXT_VIRTUE:
            return {...state, virtueStep: state.virtueStep+1};

        default:
            return state;
    }
}

export default profileReducer;